import { UserNotificationDTO } from './userNotifications.models';

export const setNotificationsQueryData = ({
  oldData,
  notificationIds,
  status,
}: {
  oldData: { [key: string]: UserNotificationDTO } | undefined;
  notificationIds: string[];
  status: UserNotificationDTO['status'];
}) => {
  const newData = notificationIds.reduce<{ [key: string]: UserNotificationDTO }>(
    (acc, cur) => {
      const oldNotification = acc[cur];

      if (oldNotification) {
        acc[cur] = { ...oldNotification, status };
      }

      return acc;
    },
    { ...oldData }
  );

  return newData;
};
